export default "__VITE_ASSET__DHKHAhcX__"